import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
// import firebase from 'firebase';
import SimpleCrypto from "simple-crypto-js";


const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
};

class Firebase {
  constructor() {
    // firebase.apps.length === 0 ? app.initializeApp(config) : firebase.app();
    app.initializeApp(config);
    /* Helper */

    this.serverValue = app.database.ServerValue;
    this.emailAuthProvider = app.auth.EmailAuthProvider;

    /* Firebase APIs */

    this.auth = app.auth();
    this.db = app.database();
    // this.fireStoreDB = firebase.firestore();

    /* Social Sign In Method Provider */

    this.googleProvider = new app.auth.GoogleAuthProvider();
    this.facebookProvider = new app.auth.FacebookAuthProvider();
    this.twitterProvider = new app.auth.TwitterAuthProvider();
  }

  // *** Auth API ***

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) => {
    let simpleCryptoObject = new SimpleCrypto('key123');
    localStorage.setItem('authUserPassword', simpleCryptoObject.encrypt(password) );
    return this.auth.signInWithEmailAndPassword(email, password);
  }

  doSignInWithGoogle = () =>
    this.auth.signInWithPopup(this.googleProvider);

  doSignInWithFacebook = () =>
    this.auth.signInWithPopup(this.facebookProvider);

  doSignInWithTwitter = () =>
    this.auth.signInWithPopup(this.twitterProvider);

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doSendEmailVerification = () =>
    this.auth.currentUser.sendEmailVerification({
      url: process.env.REACT_APP_CONFIRMATION_EMAIL_REDIRECT,
    });

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);

  // *** Merge Auth and DB User API *** //

  onAuthUserListener = (next, fallback, props) => {
    let _this = this;
   return this.auth.onAuthStateChanged(authUser => {
      if (authUser != null && !authUser.emailVerified) {
        let user = JSON.parse(localStorage.getItem('authUser'));
        if(user != null) {
          let authUserEmail = user.email;
          let simpleCryptoObject = new SimpleCrypto('key123');
          let authUserPassword = simpleCryptoObject.decrypt(localStorage.getItem('authUserPassword'));
          _this.doSignOut();
          _this.doSignInWithEmailAndPassword(authUserEmail, authUserPassword);
          props.history.push('/admin');
        }
      }
      if (authUser) {
        this.user(authUser.uid)
          .once('value')
          .then(snapshot => {
            let dbUser = snapshot.val();
            // default empty roles
            if(!dbUser) dbUser = {}
            if (!dbUser.roles) {
              dbUser.roles = {};
            }

            // merge auth and db user
            authUser = {
              uid: authUser.uid,
              email: authUser.email,
              emailVerified: authUser.emailVerified,
              providerData: authUser.providerData,
              ...dbUser,
            };

            next(authUser);
          });
      } else {
        fallback();
      }
    });
  }

  // *** User API ***

  user = uid => this.db.ref(`users/${uid}`);

  users = () => this.db.ref('users');
  
  usersCollection = () => this.db.collection("users");

  // *** Message API ***

  message = uid => this.db.ref(`messages/${uid}`);

  messages = () => this.db.ref('messages');

  dbInstance = () =>  {
    //  return this.fireStoreDB;
     }
}

export default Firebase;
